import { Injectable } from '@angular/core';
import { liteClient, LiteClient } from 'algoliasearch/lite';
import { environment } from '../../environments/environment';

export interface SearchHit {
  objectID: string;
  categoria: string;
  titulo: string;
  descripcion?: string;
  contenido?: string;
  url: string;
  imagen?: string;
  fecha?: string;
  _highlightResult?: any;
  _snippetResult?: any;
}

export interface SearchGroup {
  categoria: string;
  hits: SearchHit[];
}

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  private client: LiteClient;
  private indexName = environment.algolia.indexName;

  constructor() {
    this.client = liteClient(environment.algolia.appId, environment.algolia.searchKey);
  }

  /** Busca en el índice y devuelve los hits crudos (con highlight/snippet). */
  async search(query: string, hitsPerPage = 24): Promise<SearchHit[]> {
    const term = (query || '').trim();
    if (!term) return [];

    const { results } = await this.client.search<SearchHit>({
      requests: [
        {
          indexName: this.indexName,
          query: term,
          hitsPerPage
        }
      ]
    });

    const first: any = results[0];
    return (first?.hits ?? []) as SearchHit[];
  }

  /** Agrupa los hits por categoría, conservando el orden en que llegan de Algolia. */
  agrupar(hits: SearchHit[]): SearchGroup[] {
    const grupos = new Map<string, SearchHit[]>();
    for (const hit of hits) {
      const cat = hit.categoria || 'Otros';
      if (!grupos.has(cat)) grupos.set(cat, []);
      grupos.get(cat)!.push(hit);
    }
    return Array.from(grupos.entries()).map(([categoria, hits]) => ({ categoria, hits }));
  }
}
